import * as Website from '../../Config/Website.js';
import OverViewNum from './modules/OverViewNum.js';


const preinit = () => {

}

const init = () => {
  OverViewNum();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}